import React from 'react';
import { Globe } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';
import EditableText from './EditableText';

const GlobalReachSection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 lg:py-28 bg-[#0F172A] text-white relative overflow-hidden">
      {/* Subtle World Map Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full" 
             style={{
               backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.15'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
             }}>
        </div>
      </div>

      <div className="relative z-10 container mx-auto px-6 max-w-7xl">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex justify-center mb-6">
            <Globe className="w-14 h-14 text-blue-400" />
          </div>
          <EditableText
            section="globalReach"
            field="title"
            as="h2"
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6"
          >
            {t('globalReach.title')}
          </EditableText>
          <EditableText
            section="globalReach"
            field="description"
            as="p"
            className="text-lg sm:text-xl text-slate-300 max-w-4xl mx-auto leading-relaxed"
          >
            {t('globalReach.description')}
          </EditableText>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 max-w-5xl mx-auto">
          <div className="bg-white/5 backdrop-blur-sm p-6 sm:p-8 rounded-xl border border-white/10 hover:border-white/20 transition-all duration-300" data-testid="global-card-1">
            <EditableText
              section="globalReach"
              field="feature1Title"
              as="h3"
              className="text-xl font-bold text-blue-400 mb-3"
            >
              {t('globalReach.feature1Title')}
            </EditableText>
            <EditableText
              section="globalReach"
              field="feature1Description"
              as="p"
              className="text-slate-300 leading-relaxed"
            >
              {t('globalReach.feature1Description')}
            </EditableText>
          </div>

          <div className="bg-white/5 backdrop-blur-sm p-6 sm:p-8 rounded-xl border border-white/10 hover:border-white/20 transition-all duration-300" data-testid="global-card-2">
            <EditableText
              section="globalReach"
              field="feature2Title"
              as="h3"
              className="text-xl font-bold text-blue-400 mb-3"
            >
              {t('globalReach.feature2Title')}
            </EditableText>
            <EditableText
              section="globalReach"
              field="feature2Description"
              as="p"
              className="text-slate-300 leading-relaxed"
            >
              {t('globalReach.feature2Description')}
            </EditableText>
          </div>

          <div className="bg-white/5 backdrop-blur-sm p-6 sm:p-8 rounded-xl border border-white/10 hover:border-white/20 transition-all duration-300" data-testid="global-card-3">
            <EditableText
              section="globalReach"
              field="feature3Title"
              as="h3"
              className="text-xl font-bold text-blue-400 mb-3"
            >
              {t('globalReach.feature3Title')}
            </EditableText>
            <EditableText
              section="globalReach"
              field="feature3Description"
              as="p"
              className="text-slate-300 leading-relaxed"
            >
              {t('globalReach.feature3Description')}
            </EditableText>
          </div>

          <div className="bg-white/5 backdrop-blur-sm p-6 sm:p-8 rounded-xl border border-white/10 hover:border-white/20 transition-all duration-300" data-testid="global-card-4">
            <EditableText
              section="globalReach"
              field="feature4Title"
              as="h3"
              className="text-xl font-bold text-blue-400 mb-3"
            >
              {t('globalReach.feature4Title')}
            </EditableText>
            <EditableText
              section="globalReach"
              field="feature4Description"
              as="p"
              className="text-slate-300 leading-relaxed"
            >
              {t('globalReach.feature4Description')}
            </EditableText>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalReachSection;